import cx from 'classnames'
import React, { useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import 'react-tabs/style/react-tabs.css'

type Tab = {
  text: string
  selenium: string
  className?: string
  label?: string
}

type Props = {
  defaultIndex?: number
  tabContent: {
    tabNames: Tab[]
    tabPanels: (JSX.Element | null)[]
  }
  className?: string
  text?: string
  onChange?: (tabInfo: { tabLabel: string; tabText: string }) => void
}

const TabsGenerator = (props: Props) => {
  const { defaultIndex = 0, className, tabContent, onChange } = props
  const [activeTab, setActiveTab] = useState<number>(defaultIndex)

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <Tabs
        selectedIndex={activeTab}
        onSelect={tabIndex => {
          if (tabIndex !== activeTab) {
            setActiveTab(tabIndex)
            onChange?.({
              tabLabel: tabContent?.tabNames[tabIndex]?.label as string,
              tabText: tabContent?.tabNames[tabIndex]?.text?.split(' ')[0]
            })
          }
        }}>
        <TabList
          className={`[ f-wrap ] TabsGenerator-tab-list ${className || ''}`}>
          {tabContent.tabNames.map((tabName: Tab, index: number) => {
            return (
              <Tab
                key={index}
                className={cx('TabsGenerator-tab-item', tabName.className)}
                data-sel={tabName.selenium}>
                {tabName.text}
              </Tab>
            )
          })}
        </TabList>
        {tabContent.tabPanels.map((tabPanel, index) => {
          return (
            <TabPanel key={index} className='[ f-c-fo-whi ]'>
              {tabPanel}
            </TabPanel>
          )
        })}
      </Tabs>
    </TabsContext.Provider>
  )
}

const TabsContext = React.createContext<{
  activeTab: number
  setActiveTab: React.Dispatch<React.SetStateAction<number>>
} | null>({ activeTab: 0, setActiveTab: () => {} })

export const useTabsContext = () => {
  const context = React.useContext(TabsContext)
  if (!context) {
    throw new Error('useTabsContext must be used within a TabsProvider')
  }
  return context
}

export default TabsGenerator
